// Cidades por UF via API pública do IBGE (localidades) — evita empacotar ~5.570 municípios no
// bundle (o padrão hoje usado para os 27 estados, `brazilianStates.js`, não escala pra cidade:
// a lista de UFs é fixa e pequena, a de municípios não). Resultado cacheado por UF: trocar de
// estado e voltar não refaz a chamada.
const CACHE = new Map();

export const IBGE_MUNICIPIOS_URL = (uf) => (
  `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
);

export const fetchCitiesByState = async (uf, { fetchImpl = fetch } = {}) => {
  if (!uf) return [];
  if (CACHE.has(uf)) return CACHE.get(uf);
  const response = await fetchImpl(IBGE_MUNICIPIOS_URL(uf));
  if (!response?.ok) throw new Error("Não foi possível carregar as cidades");
  const data = await response.json();
  const cities = (Array.isArray(data) ? data : [])
    .map((entry) => entry?.nome)
    .filter((name) => typeof name === "string" && name.length > 0)
    .sort((a, b) => a.localeCompare(b, "pt-BR"));
  CACHE.set(uf, cities);
  return cities;
};

// Exposto só para os testes limparem o cache entre casos (`CACHE` é module-level, então
// persiste entre `render()` diferentes no mesmo arquivo de teste).
export const __clearCitiesCache = () => CACHE.clear();
